export default class ContentNavigationHelper {
  static scrollToTop = (selector: string) => {
    const element = document.querySelector(selector);

    if (element) {
      element.scrollTo({ top: 0 });
    }
  };

  static scrollToSectionInResource = (
    linkedResourceId: string,
    sectionId: string,
    smooth: boolean
  ) => {
    const linkedResource = document.getElementById(linkedResourceId);
    const target = linkedResource.querySelector(`[id="${sectionId}"]`);
    const container = document.querySelector('.presentation');

    if (!container || !target) {
      return;
    }

    const resourceOffsetTop = 30;

    container.scrollTo({
      top:
        target.getBoundingClientRect().top -
        resourceOffsetTop +
        container.scrollTop -
        container.getBoundingClientRect().top,
      left: 0,
      behavior: smooth ? 'smooth' : 'instant',
    });
  };

  static scrollToTarget = (containerSelector: string, targetId: string, smooth = true) => {
    const container = document.querySelector(containerSelector);
    const target = document.getElementById(targetId);

    if (!container || !target) {
      return;
    }

    container.scrollTo({
      top:
        target.getBoundingClientRect().top +
        container.scrollTop -
        container.getBoundingClientRect().top,
      left: 0,
      behavior: smooth ? 'smooth' : 'instant',
    });
  };
}
